export default {
  ADMIN: "Admin",
  MODERATOR: "Moderator",
  USER: "User",
};

export const cardContentStyle = {
  width: "100%",
  height: "250px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
  objectFit: "cover",
};
